import { inject, observer } from 'mobx-react'
import React from 'react'
import { Helmet } from 'react-helmet'
import AppPageHeader from '../../../../components/AppPageHeader'
import DashboardLayout from '../../../../layouts/DashboardLayout'
import OtherSubmissionFormV2 from './OtherSubmissionFormV2'

const CreateProposalPageV2 = props => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Hành chính | Tạo mới hành chính</title>
      </Helmet>
      <AppPageHeader title="Tạo mới hành chính" />
      <OtherSubmissionFormV2 />
    </DashboardLayout>
  )
}

export default inject(
  'proposalStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'proposalTypeStore'
)(observer(CreateProposalPageV2))
